import { getConfigurationEffectiveQuantity } from 'helpers/DealQuantity';
/**
 * @function getPricePerUnitFromMarkup
 * @since 1.0.0
 * @hidden
 */
export function getPricePerUnitFromMarkup(cost, markup) {
    let pricePerUnit = cost;
    if (markup !== 0) {
        pricePerUnit = cost + (markup / 100) * cost;
    }
    return pricePerUnit;
}
/**
 * @function getPricePerUnitFromMargin
 * @since 1.0.0
 * @hidden
 */
export function getPricePerUnitFromMargin(cost, margin) {
    let pricePerUnit = cost;
    if (margin !== 0) {
        pricePerUnit = cost / (1 - margin / 100);
    }
    return pricePerUnit;
}
/**
 * @function getMarkup
 * @since 1.0.0
 * @hidden
 */
export function getMarkup(cost, pricePerUnit) {
    return pricePerUnit !== 0 && cost !== 0
        ? ((pricePerUnit - cost) / cost) * 100
        : 0;
}
/**
 * @function getMargin
 * @since 1.0.0
 * @hidden
 */
export function getMargin(cost, pricePerUnit) {
    return pricePerUnit !== 0 && cost !== 0
        ? ((pricePerUnit - cost) / pricePerUnit) * 100
        : 0;
}
/**
 * @function getPriceFromItem
 * @since 1.0.0
 * @hidden
 */
export function getPriceFromItem(item, variant, element, type, currency) {
    let price = element && element.price ? element.price : 0;
    if (element == null)
        return calculatePriceCurrency(price, currency);
    // get price from item
    item.options.find((option) => {
        if (option.item.id == element.id) {
            price = option.price;
        }
    });
    // get price from variant
    if (variant) {
        variant.options.find((option) => {
            if (option.item.id == element.id) {
                price = option.price;
            }
        });
    }
    return calculatePriceCurrency(price, currency);
}
/**
 * @function getDealItemTotal
 * @since 1.0.0
 * @hidden
 * */
export function getDealItemTotal(item) {
    let total = 0;
    total += item.price;
    if (item.packages) {
        item.packages.forEach((pack) => {
            if (!pack.proposed) {
                total += pack.price;
            }
        });
    }
    if (item.options) {
        item.options.forEach((option) => {
            if (!option.proposed) {
                total += option.price;
            }
        });
    }
    return total;
}
/**
 * @function getDealItemTotalWithQuantity
 * @since 1.0.0
 * @hidden
 * */
export function getDealItemTotalWithQuantity(item, includeItemConfiguration = true, deal) {
    let total = 0;
    total += item.price * item.quantity;
    if (item.packages && includeItemConfiguration) {
        item.packages.forEach((pack) => {
            var _a;
            if (!pack.proposed) {
                const effectiveQty = getConfigurationEffectiveQuantity(pack.quantity, (_a = pack.package) === null || _a === void 0 ? void 0 : _a.quantityCalculation, deal);
                total += pack.price * effectiveQty;
            }
        });
    }
    if (item.options && includeItemConfiguration) {
        item.options.forEach((option) => {
            var _a;
            if (!option.proposed) {
                const effectiveQty = getConfigurationEffectiveQuantity(option.quantity, (_a = option.item) === null || _a === void 0 ? void 0 : _a.quantityCalculation, deal);
                total += option.price * effectiveQty;
            }
        });
    }
    return total;
}
/**
 * @function getDealItemConfigurationTotalWithQuantity
 * @since 1.0.0
 * @hidden
 * */
export function getDealItemConfigurationTotalWithQuantity(item, type, deal) {
    let total = 0;
    if (item.packages && type === 'packages') {
        item.packages.forEach((pack) => {
            var _a;
            if (!pack.proposed) {
                const effectiveQty = getConfigurationEffectiveQuantity(pack.quantity, (_a = pack.package) === null || _a === void 0 ? void 0 : _a.quantityCalculation, deal);
                total += pack.price * effectiveQty;
            }
        });
    }
    if (item.options && type === 'options') {
        item.options.forEach((option) => {
            var _a;
            if (!option.proposed) {
                const effectiveQty = getConfigurationEffectiveQuantity(option.quantity, (_a = option.item) === null || _a === void 0 ? void 0 : _a.quantityCalculation, deal);
                total += option.price * effectiveQty;
            }
        });
    }
    return total;
}
/**
 * @function calculatePriceCurrency
 * @since 1.0.0
 * @hidden
 * */
export function calculatePriceCurrency(amount, currency) {
    if (!currency || currency.primary) {
        return amount;
    }
    const rate = currency.rate || 1;
    return amount * rate;
}
/**
 * @function getDiscountRep
 * @since 1.0.0
 * @hidden
 */
export function getDiscountRep(contact) {
    var _a;
    if ((contact === null || contact === void 0 ? void 0 : contact.discount) != null) {
        return Number(contact.discount);
    }
    if (((_a = contact === null || contact === void 0 ? void 0 : contact.client) === null || _a === void 0 ? void 0 : _a.discount) != null) {
        return Number(contact.client.discount);
    }
    return 0;
}
